export const wrapperIdentifier = 'dniScanner';
